import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPanelPage from "./pages/AdminPanelPage";
import GptChatPage from "./pages/GptChatPage";
import BrainPage from "./pages/BrainPage";

import VerifyEmailPage from "./pages/VerifyEmailPage";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/MainLayout";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import AccessExpiredPage from "./pages/AccessExpiredPage";
import "./css/theme.css";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Protected Routes with shared layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly={true}>
              <MainLayout>
                <AdminPanelPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gpt/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <GptChatPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/brain"
          element={
            <ProtectedRoute>
              <MainLayout>
                <BrainPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/password-reset" element={<ForgotPasswordPage />} />
        <Route path="/access-expired" element={<AccessExpiredPage />} />
      </Routes>
    </Router>
  );
}

export default App;
